export default __webpack_public_path__ + "static/facebook-b293d5363351752caf250d887fef42c4.png";